import { forwardRef, useEffect, useMemo } from 'react';

import { useFocusInputFunctionality } from 'core/hooks';
import { FormProvider } from 'core/states';
import { IUpsertPartBomForm, UpsertPartBomCreateType } from 'partBoms/components/UpsertPartBom';

import { DetailsFormFields } from './DetailsFormFields';
import { partBomUpsertDetailsSchema } from './schema';

interface IProps {
  onClose: () => void;
  defaultValues: IUpsertPartBomForm;
  isEdit?: boolean;
}

export const Details = forwardRef(function Details(
  { onClose, defaultValues: customDefaultValues, isEdit = false }: IProps,
  ref
) {
  const { setFocusElementName } = useFocusInputFunctionality();

  useEffect(() => {
    setFocusElementName('number');
  }, [setFocusElementName]);

  const defaultValues = useMemo(() => {
    return {
      createType: UpsertPartBomCreateType.NEW,
      ...customDefaultValues,
    };
  }, [customDefaultValues]);

  return (
    <FormProvider
      schema={partBomUpsertDetailsSchema()}
      defaultValues={defaultValues}
      resetDefaultValues
    >
      <DetailsFormFields ref={ref} onClose={onClose} isEdit={isEdit} />
    </FormProvider>
  );
});
